import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import Spinner from '../../Spinner';
var StyledSpinner = styled(Spinner)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    left: unset;\n    right: 2.5rem;\n    top: 1.4rem;\n"])));
export default StyledSpinner;